import { useTranslation } from 'react-i18next';

export default function HowItWorks() {
  const { t } = useTranslation();
  const steps = ['step1', 'step2', 'step3'];
  return (
    <section id="how-it-works" className="bg-surface border-t border-border">
      <div className="mx-auto max-w-5xl px-5 py-14 md:py-18">
        <div className="text-center mb-8">
          <h2 className="text-[24px] md:text-[28px] font-bold tracking-tight">{t('howItWorks.section.title')}</h2>
          <p className="mt-2 text-[15px] text-muted">
            {t('howItWorks.section.subtitle')}
          </p>
        </div>
        <ol className="grid gap-6 md:grid-cols-3">
          {steps.map((step, idx) => (
            <li
              key={step}
              className="relative flex flex-col items-center text-center rounded-xl border border-border bg-bg p-6"
            >
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-primary text-[15px] font-bold text-white">
                {idx + 1}
              </div>
              <div className="mb-2 text-[16px] font-semibold text-ink">{t(`howItWorks.${step}.title`)}</div>
              <div className="text-[14px] leading-[1.55] text-muted">{t(`howItWorks.${step}.description`)}</div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
